import type { FormControl } from '@angular/forms';

import { isEmpty } from '@recruitee/utils';

const WITHOUT_PATTERN = /^(?!.*:\/\/www\.)(?!www\.).*$/i;

export function withoutWwwValidator(
  control: FormControl<string | null>,
): { withoutWww: boolean } | null {
  if (isEmpty(control.value)) return null;

  try {
    const url = new URL(control.value);
    return url.hostname.startsWith('www.') ? { withoutWww: true } : null;
  } catch {
    return WITHOUT_PATTERN.test(control.value) ? null : { withoutWww: true };
  }
}
